import {IntermediatePart} from "../../intermediatePart";
import {getFeatureIsLocked} from "../../../../../misc/helpers";
// import store from "../../../../../store";
// import {setLookOverlayOpened} from "../../../../../actions/lookFunctions";
// import {LOOK_OVERLAYS} from "../../constants";
// import {Shower} from "../../parts/shower";

export default class TubCommon extends IntermediatePart {

  constructor(isChild) {
    super(isChild);
  }

  disabledClick() {}

  applyFeatureIfNotCompatible() {
    const showerTubComboParent = this.getParent().getParent();
    showerTubComboParent.setShowerTubCombo();
    showerTubComboParent.setActiveTub(this.bottomTubId);
  }

  handleClick(ignoreLocked) {
    super.handleClick(ignoreLocked);

    if (this.notAvailableInVisualizer || getFeatureIsLocked(this)) {
      return
    }

    // const showerTubComboParent = this.getParent().getParent();
    // const currentBottomTub = showerTubComboParent.bottomTub;
    //
    // const showNotCompatibleViewConditions = !window.location.hash.includes("visualizer") &&
    //   (!showerTubComboParent.showerTubComboIsActive || (
    //     (this.partId === "walk_in_tub" && currentBottomTub !== "walk_in_tub") || (this.partId !== "walk_in_tub" && currentBottomTub === "walk_in_tub")
    //   ));
    //
    // if (showNotCompatibleViewConditions) {
    //   store.dispatch(setLookOverlayOpened(LOOK_OVERLAYS.notCompatiblePopup));
    //   return;
    // }

    this.applyFeatureIfNotCompatible();
    this.featureClicked();
  }

  getArrayOfConditions() {
    let conditions = super.getArrayOfConditions(); //roomLayout
    // const layout = this.getParent().layout;
    // const showerParent = layout.parts[Shower.id];
    // const showerSize = showerParent.showerSize();
    // if (showerParent && showerSize) {
    //   conditions.push({
    //     propName: "ShowerSize",
    //     propValue: showerSize
    //   });
    // }
    return conditions
  }

  hideLayerCondition() {
    const showerTubComboParent = this.getParent();
    return !showerTubComboParent.showerTubComboIsActive || showerTubComboParent.bottomTub !== this.bottomTubId
  }

  canDisplayDemoPoint() {
    return !this.hideLayerCondition()
  }

}
